import { render, staticRenderFns } from "./Exhausted.vue?vue&type=template&id=6c48c964&"
import script from "./Exhausted.vue?vue&type=script&lang=js&"
export * from "./Exhausted.vue?vue&type=script&lang=js&"
import style0 from "./Exhausted.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Exhausted.vue"
export default component.exports